<template lang="pug">
  tr.row
    StartingBusinessTableFavoriteStar(:startingBusiness="startingBusiness", @update="update", :updateFavorForIndex="updateFavorForIndex")
    td.col.check
      label.checkbox
        input(
          type="checkbox",
          :value="startingBusiness.id",
          :checked='checked',
          :disabled="isGlobalLocked",
          @click="check($event, startingBusiness.id)"
        )
    td.col(class="company_name")
      span.new(v-if="startingBusiness.is_new") NEW
      a(@click="display") {{ startingBusiness.facility_name }}
    td.col
      | {{ startingBusiness.genre }}
    td.col
      | {{ startingBusiness.phone_number }}
    td.col
      | {{ startingBusiness.prefecture_name }} {{ startingBusiness.city_name }}
    td.col
      | {{ startingBusiness.applicant_position_name }}
    td.col
      | {{ startingBusiness.corporate_name }}
    td.col
      | {{ startingBusiness.search_date }}
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import StartingBusinessTableFavoriteStar from './StartingBusinessTableFavoriteStar'

  export default {
    components: { StartingBusinessTableFavoriteStar },
    props: ['startingBusiness', 'modal', 'checkedIds', 'updateFavorForIndex'],
    computed: {
      ...mapGetters('common', ['isGlobalLocked']),
      checked () {
        return this.checkedIds.has(this.startingBusiness.id)
      },
    },
    methods: {
      ...mapMutations('startingBusiness', ['clearDetail']),
      check (event, id) {
        event.preventDefault()
        const checked = event.currentTarget.checked
        this.$emit('check', { checked, id })
      },
      display (e) {
        e.stopPropagation()
        this.$emit('display', { id: this.startingBusiness.id })
      },
      update () {
        this.clearDetail()
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/StartingBusinessTableRow.vue